import React, {Component} from 'react';
import VariantSelector from './VariantSelector';
import {Link} from 'react-router-dom';
import {Row, Col, Modal, ModalBody} from 'reactstrap';
import {SoldOut} from './SoldOut';

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  PinterestIcon,
  PinterestShareButton,
  TumblrShareButton,
  TumblrIcon,
} from 'react-share';

let NULL_IMAGE =
  'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_grande.gif';
class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      unavailable: false,
      soldout: !this.props.product.variants[0].attrs.available.value,
      selectedVariant: this.props.product.variants[0],
    };

    this.handleMetaChanges();
  }

  componentWillMount() {
    var opt = {};
    this.props.product.options.forEach(selector => {
      let key = selector.name;
      opt[key] = selector.values[0].value;
    });

    var image = this.props.product.images[0];
    this.setState({
      selectedOptions: opt,
      selectedImage: image ? image.src : NULL_IMAGE,
    });
  }

  findImage(images, variantId) {
    const primary = images[0];
    const image = images.filter(function(image) {
      return image.variant_ids.includes(variantId);
    })[0];
    return (image || primary).src;
  }

  handleOptionChange = (event) => {
    const target = event.target;
    let selectedOptions = this.state.selectedOptions;
    selectedOptions[target.name] = target.value;

    const selectedVariant = this.props.client.product.helpers.variantForOptions(
      this.props.product,
      selectedOptions,
    );

    //Selected variant not found
    if (!selectedVariant) {
      this.setState({
        unavailable: true,
      });
      return;
    }

    this.setState({
      selectedVariant: selectedVariant,
      selectedVariantImage: selectedVariant.attrs.image,
      selectedOptionVariantImage: selectedVariant.attrs.image, // separate shown image from cart image i.e. selectedVariantImage vs selectedOptionVariantImage
      unavailable: false,
      soldout: !selectedVariant.attrs.available.value,
    });
  }

  handleQuantityChange = (event) => {
    this.setState({
      selectedVariantQuantity: event.target.value,
    });
  }

  handleImageChange = (event) => {
    this.setState({
      selectedVariantImage: {src: event.target.src},
    });
  }

  handleAddItemToCart = (variantId, variantQuantity) => {
    //Add variant image to localstorage
    //    let variantImage =  this.props.product.images[0].src

    let variantImage = this.state.selectedOptionVariantImage
      ? this.state.selectedOptionVariantImage.src
      : this.props.product.images[0]
      ? this.props.product.images[0].src
      : NULL_IMAGE;
    localStorage.setItem(variantId, variantImage);
    this.props.addVariantToCart(variantId, variantQuantity);
  }

  /*
   * Set up listener to change meta og:image / og:description
   */
  handleMetaChanges = () => {
    if (!document.head.querySelector("[property='og:image']")) {
      return;
    }

    let variantImage =
      this.state.selectedVariantImage && this.state.selectedVariantImage.src
        ? this.state.selectedVariantImage.src
        : this.props.product.images[0]
        ? this.props.product.images[0].src
        : NULL_IMAGE;
    let variant = this.state.selectedVariant;
    document.head
      .querySelector("[property='og:image']")
      .setAttribute('content', variantImage);
    document.head
      .querySelector("[property='og:image:url']")
      .setAttribute('content', variantImage);
    document.head
      .querySelector("[property='og:image:secure_url']")
      .setAttribute('content', variantImage);
    document.head
      .querySelector("[property='og:title']")
      .setAttribute('content', this.props.product.title);
    document.head
      .querySelector("[property='og:description']")
      .setAttribute('content', this.props.product.description);
    document.head
      .querySelector("[itemprop='productID']")
      .setAttribute('content', this.props.product.id);
    document.head
      .querySelector("[itemprop='category']")
      .setAttribute('content', this.props.product.productType);
    document.head
      .querySelector("[itemprop='brand']")
      .setAttribute('content', this.props.product.vendor);
    document.head
      .querySelector("[itemprop='price']")
      .setAttribute('content', variant.price);
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  }

  //Specifically for unavailble button
  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var c = result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
    if (!c) return hex;
    return 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',0.6)';
  }

  //For description, since the html is coming from Shopify it should be safe
  createHTMLMarkup() {
    return {__html: this.props.product.descriptionHtml};
  }

  render() {
    let variantImage =
      this.state.selectedVariantImage && this.state.selectedVariantImage.src
        ? this.state.selectedVariantImage.src
        : this.props.product.images[0]
        ? this.props.product.images[0].src
        : NULL_IMAGE;
    let variant = this.state.selectedVariant || this.props.product.variants[0];
    let variantQuantity = this.state.selectedVariantQuantity || 1;
    var compareAtPrice = <div />;

    //Show/hide compareAtPrice
    if (variant.compareAtPrice) {
      var priceStyle;
      if (this.props.more) {
        priceStyle = this.props.style.productPriceColor;
      } else {
        priceStyle = this.props.style.collectionProductPriceColor;
      }
      compareAtPrice = (
        <div
          className="Product__compare_price"
          style={(priceStyle, {display: 'inline-block'})}>
          ${variant.compareAtPrice}
        </div>
      );
    }

    let variantSelectors = this.props.product.options.map(option => {
      if (option.values.length === 1) return <br />;
      return (
        <VariantSelector
          handleOptionChange={this.handleOptionChange}
          key={option.id.toString()}
          option={option}
        />
      );
    });

    //The preview/thumbnail images
    let imageComponent = this.props.product.images.map(image => {
      return (
        <li onClick={this.handleImageChange} key={'preview-' + image.src}>
          <img
            src={image.src}
            width="50px"
            className="Product__thumbnail"
            alt={this.props.product.title}
          />
        </li>
      );
    });

    //If show more information about product
    if (this.props.more) {
      //Add to cart button or unavailable button
      var button = (
        <span
          className="Product__buy button"
          style={this.props.style.addToCartButton}
          onClick={() => {
            this.handleAddItemToCart(variant.id, variantQuantity);
          }}>
          ADD TO CART
        </span>
      );

      if (this.state.unavailable || this.state.soldout) {
        var style = {
          backgroundColor: this.props.style.addToCartButton.backgroundColor,
          color: this.hexToRgb(this.props.style.addToCartButton.color),
        };
        button = (
          <span
            className="Product__buy Product__buy-unavailable button"
            style={style}>
            {this.state.unavailable === true ? 'UNAVAILABLE' : 'SOLD OUT'}
          </span>
        );
      }

      return (
        <Row>
          <Col xs="12" md="6">
            {this.props.product.images ? (
              <img
                src={variantImage}
                onClick={this.toggle}
                alt={`${this.props.product.title} product shot`}
              />
            ) : null}
            <br />
            <ul className="Product__image-list">{imageComponent}</ul>
            <div>
              <strong style={this.props.style.productPriceColor}>
                {' '}
                SHARE WITH FRIENDS{' '}
              </strong>
            </div>
            <div className="ShareButton">
              <div onClick={this.handleMetaChanges}>
                <FacebookShareButton
                  url={window.location.href}
                  quote={'Check out '}
                  hashtag="#AnnArborTees"
                  className="Demo__some-network__share-button">
                  <FacebookIcon size={32} />
                </FacebookShareButton>
              </div>
              <TwitterShareButton
                url={window.location.href}
                title="Check out "
                hashtags={['AnnArborTees']}
                className="Demo__some-network__share-button">
                <TwitterIcon size={32} />
              </TwitterShareButton>
              <PinterestShareButton
                url={window.location.href}
                media={variantImage}
                tags={['AnnArborTees']}
                className="Demo__some-network__share-button">
                <PinterestIcon size={32} />
              </PinterestShareButton>
              <TumblrShareButton
                url={window.location.href}
                quote={'quote'}
                className="Demo__some-network__share-button">
                <TumblrIcon size={32} />
              </TumblrShareButton>
            </div>
          </Col>
          <Col xs="12" md="6">
            <h1 style={this.props.style.productTitleColor}>
              {this.props.product.title}
            </h1>
            <div>
              <p className="Product__detail_price">
                <strong style={this.props.style.productPriceColor}>
                  ${variant.price}
                </strong>
                <small className="Product__detail_old_price">
                  {' '}
                  {compareAtPrice}
                </small>
              </p>
            </div>
            {variantSelectors}
            <div>
              <input
                className="Product__quantity no-spinners"
                min="1"
                type="number"
                defaultValue={variantQuantity}
                onChange={this.handleQuantityChange}
              />
              {button}
            </div>
            <br />
            <p
              className="Product__description"
              style={this.props.style.productDescColor}
              dangerouslySetInnerHTML={this.createHTMLMarkup()}
            />
          </Col>
          <Modal isOpen={this.state.modal} toggle={this.toggle}>
            <ModalBody style={this.props.style.bodyBackgroundColor}>
              <br />
              {this.props.product.images.length ? (
                <img
                  src={variantImage}
                  className="Modal__preview-button col-lg-12"
                  alt={`${this.props.product.title} product shot`}
                />
              ) : null}
            </ModalBody>
            <div
              className="Modal__footer"
              style={this.props.style.bodyBackgroundColor}>
              <div
                className="button Modal__preview-button"
                color="primary"
                style={this.props.style.addToCartButton}
                onClick={this.toggle}>
                Close
              </div>
            </div>
          </Modal>
        </Row>
      );
    }

    //Should show product price and title
    var displayProduct = <div />;
    var displayTitle = <div />;
    if (this.props.style.collectionDisplayProductPrice) {
      displayProduct = (
        <div id="Price__container">
          <span
            className="Product__price"
            style={this.props.style.collectionProductPriceColor}>
            ${variant.price}
          </span>
          {compareAtPrice}
        </div>
      );
    }
    if (this.props.style.collectionDisplayProductTitle) {
      displayTitle = (
        <h6
          className="Product__title"
          style={this.props.style.collectionProductTitleColor}>
          <strong>{this.props.product.title}</strong>
        </h6>
      );
    }

    let isSoldOut = !this.props.product.variants.map(v => {
      return v.attrs.available.value;
    }).reduce((next,res)=>{if(next && res){return true}; return res;}, true)

    return (
      <div className=" col-md-12 col-lg-6 col-xl-4">
        <div className="Product Product__cont">
          <Link
            to={'/products/' + this.props.product.handle}
            style={{textDecoration: 'none'}}>
            {this.props.product.images ? (
              <div>
                <img
                  style={this.props.style.collectionImageBackgroundColor}
                  className="Product__image"
                  src={variantImage}
                  alt={`${this.props.product.title} product shot`}
                />
                {isSoldOut ? <SoldOut/> : <div/>}
              </div>
            ) : null}
            {displayTitle}
            {displayProduct}
          </Link>
        </div>
      </div>
    );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Product.js